<template>
  <div>
    <div>
      <div class="top">
        <div class="left">
          <h1 v-scroll-reveal="{ delay: 200, reset: false }">
            It’s not rocket science.<br />It only takes a few simple rules.
          </h1>
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 43.1 85.9"
            style="enable-background:new 0 0 43.1 85.9;"
            xml:space="preserve"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              class="st0 draw-arrow"
              d="M11.3,2.5c-5.8,5-8.7,12.7-9,20.3s2,15.1,5.3,22c6.7,14,18,25.8,31.7,33.1"
            />
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              class="draw-arrow tail-1"
              d="M40.6,78.1C39,71.3,37.2,64.6,35.2,58"
            />
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              class="draw-arrow tail-2"
              d="M39.8,78.5c-7.2,1.7-14.3,3.3-21.5,4.9"
            />
          </svg>
        </div>
        <div class="right">
          <div v-scroll-reveal>
            <h2>Build to last</h2>
            <p>
              We build for our customers' customer. Together with our clients.
              That means challenging the status quo and finding new
              opportunities. We have to strive for perfection. Although nothing
              ever stays perfect, the rules change every day and the future has
              already started. We know that. That’s why we are always on our
              toes, prepared.
            </p>
          </div>
          <div v-scroll-reveal="{ viewOffset: { bottom: 400 } }">
            <h2>Be proud</h2>
            <p>
              We are dependable. We don’t hesitate to walk that extra mile to
              get things done the right way. Maybe its pride, maybe it’s just us
              being pedantic. But we stand by our product.
            </p>
          </div>
          <div v-scroll-reveal="{ viewOffset: { bottom: 400 } }">
            <h2>Be honest and transparent</h2>
            <p>
              Collaboration is the key to any successful project. We see
              ourselves as an external in-house department. As our client (or
              sort of colleague) you get a dedicated and adaptable team that is
              never more than a digital arm’s-length away.
            </p>
          </div>
          <div v-scroll-reveal="{ viewOffset: { bottom: 400 } }">
            <h2>The user comes first</h2>
            <p>
              We work with design and tech. Prototypes, wireframes, code,
              platforms, systems, requirements. The list goes on. But does it
              really matter? Sorry, of course it does. It matters to us. To our
              clients, too. But not for the end consumer. People tend to forget
              that. When we do our job right, nobody even notices.
            </p>
          </div>
          <div v-scroll-reveal="{ viewOffset: { bottom: 400 } }">
            <h2>It's all about business value</h2>
            <p>
              To be honest — it’s all about the bottom line. If our clients are
              not successful, we are not successful. Throughout the process.
              From start to finish and onwards. Let’s do it together.
            </p>
          </div>
        </div>
      </div>
      <div class="top">
        <div class="left">
          <h1 v-scroll-reveal="{ delay: 200, reset: false }">So, why us?</h1>
        </div>
        <div class="right">
          <div v-scroll-reveal>
            <h2>It's not our first rodeo</h2>
            <p>
              For over 10 years we’ve been working with clients in all
              industries and all sizes. We’ve handled challenging assignments
              for top performing brands as well as startups. From start to
              finish or niche jobs. It's not our first rodeo.
            </p>
          </div>
          <div v-scroll-reveal="{ viewOffset: { bottom: 400 } }">
            <h2>Equal love for both design and tech</h2>
            <p>
              We love making things look simple — but it has to come from a
              strong foundation. In other words, the backend is as important as
              the frontend and neither can live without the other. We build
              bespoke solutions or work with existing technology and systems. It
              all depends, but we’ll help you find the way!
            </p>
          </div>
          <div v-scroll-reveal="{ viewOffset: { bottom: 400 } }">
            <h2>Platform independent</h2>
            <p>
              Which platform is the best one? The question was probably first
              asked by the Egyptians and lets face it, there are a lot of
              different ones to choose from. Open source or licensed — we love
              them all and we pride ourselves on being platform independent. We
              live by a simple yet powerful rule: User first. Platform second.
            </p>
          </div>
        </div>
      </div>
      <Services :show-more="false" />
    </div>
    <StartProject />
    <Footer />
  </div>
</template>
<script>
import StartProject from "@/components/home/StartProject.vue";
import Footer from "@/components/Footer.vue";
import Services from "@/components/home/Services.vue";
export default {
  name: "services",
  components: {
    StartProject,
    Footer,
    Services
  },
  beforeCreate: function() {
    document.body.classList.remove("dark");
    document.body.classList.remove("invert");
  },
  methods: {
    invertColor() {
      if (
        window.scrollY >
        document.body.clientHeight - window.innerHeight - 500
      )
        document.body.classList.add("invert");
      else document.body.classList.remove("invert");
    }
  },
  created() {
    window.addEventListener("scroll", this.invertColor);
  },
  destroyed() {
    window.removeEventListener("scroll", this.invertColor);
  }
};
</script>

<style lang="scss" scoped>
@import "./src/assets/css/typography.scss";
.top {
  z-index: 1;
  position: relative;
  padding: 20vh 5.3%;
  .left {
    position: sticky;
    top: 20vh;
    h1 {
      @include headline-medium;
      width: 40%;
      z-index: 2;
      position: relative;
      //float:left;
    }
    svg {
      width: 12vw;
      height: 12vw;
      margin: 0 auto;
      position: absolute;
      top: 13vh;
      left: 25vw;
      transform: rotate(-20deg);
      z-index: 1;
      display: none;
      .draw-arrow {
        stroke-width: 1.3;
        stroke: #ff8686;
        fill: none;
        stroke-dasharray: 400;
        stroke-dashoffset: 400;
        animation-duration: 2s;
        animation-fill-mode: forwards;
        animation-name: draw;
        animation-delay: 1s;
        &.tail-1 {
          animation-delay: 1.5s;
        }
        &.tail-2 {
          animation-delay: 1.7s;
        }
      }
    }
    @keyframes draw {
      to {
        stroke-dashoffset: 0;
      }
    }
  }
  .right {
    //float:right;
    width: 40%;
    margin-left: calc(50% + 1vw);
    margin-top: 10vh;
    > div {
      h2 {
        @include headline-small;
        &:before {
          content: "";
          position: absolute;
          left: -2vw;
          top: -2vh;
          width: 2vw;
          height: 2vw;
          display: block;
          font-size: 1vw;
          letter-spacing: 0;
          border-radius: 2vh;
          border: 1px solid inherit;
          line-height: 2vw;
          text-align: center;
          //display:none;
        }
      }
      p {
        margin-bottom: 30vh;
      }
      &:nth-child(1) h2 {
        &:before {
          content: "1";
        }
      }
      &:nth-child(2) h2 {
        &:before {
          content: "2";
        }
      }
      &:nth-child(3) h2 {
        &:before {
          content: "3";
        }
      }
      &:nth-child(4) h2 {
        &:before {
          content: "4";
        }
      }
      &:nth-child(5) h2 {
        &:before {
          content: "5";
        }
      }
    }
  }
}
.blocks {
  display: none;
}
.container:not(footer) {
  display: flex;
  .fifty {
    width: 50%;
    margin: 1vw;
    img {
      width: 100%;
    }
    h3 {
      @include headline-small;
    }
  }
}
@media (max-width: $tablet) {
  .top {
    padding: 100px 50px;
  }
}
@media (max-width: $mobile) {
  .top {
    padding: 100px 30px;
    .left {
      top: 0;
      position: relative;
      h1 {
        width: 100%;
        margin-bottom: 100px;
      }
      svg {
        width: 100px;
        height: 100px;
        bottom: -60px;
        top: auto;
        left: -40px;
        transform: rotate(20deg);
      }
    }
    .right {
      width: 100%;
      margin-left: 0;
      margin-top: 0;
      > div {
        h2 {
          &:before {
            display: none;
          }
        }
        p {
          margin-bottom: 50px;
        }
      }
    }
  }
  .container:not(footer).indent {
    padding: 50px 30px;
    flex-direction: column;
    .fifty {
      width: 100%;
      margin: 0;
      margin-bottom: 30px;
    }
  }
}
</style>
